import type { ComponentProps, ReactNode } from "react";
import { cn } from "../../lib/utils";

export const badgeToneClasses = {
  neutral: "bg-muted text-muted-foreground border-border",
  success: "bg-success-subtle text-success border-success-border",
  info: "bg-info-subtle text-info border-info-border",
  warning: "bg-warning-subtle text-warning border-warning-border",
  danger: "bg-danger-subtle text-danger border-danger-border",
} as const;
export type BadgeTone = keyof typeof badgeToneClasses;

export function Badge({ children, className, tone, icon, iconPosition = "start", ...props }: Readonly<ComponentProps<"span"> & {
  tone?: BadgeTone;
  icon?: ReactNode;
  iconPosition?: "start" | "end";
}>) {
  const adornment = icon ? <span className="badge-icon">{icon}</span> : null;
  return <span {...props} className={cn("badge", tone && badgeToneClasses[tone], className)}>
    {iconPosition === "start" ? adornment : null}
    <span className="badge-label">{children}</span>
    {iconPosition === "end" ? adornment : null}
  </span>;
}
